import React, { useState } from 'react';

interface TooltipBoxProps {
    message: string;
    position?: {
        bottom?: string;
        top?: string;
        left?: string;
        right?: string;
    };
}

const TooltipBox: React.FC<TooltipBoxProps> = ({ message, position }) => {

    const tooltipStyle: React.CSSProperties = {
        position: 'absolute',
        backgroundColor: '#555',
        color: 'white',
        textAlign: 'center',
        padding: '5px',
        borderRadius: '6px',
        zIndex: 5,
        width: 'max-content',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        maxWidth: '15em',
        ...position
    };

    return (
        <div style={tooltipStyle}>
            {message}
        </div>
    );
};

export default TooltipBox;